
import {defineComponent, ref, watch} from "vue";
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.js";
import {Actions} from "@/store/enums/StoreEnums";
import {useStore} from "vuex";

export default defineComponent({
  name: "edit-product-modal",
  props: ["product", "reloadData"],
  components: {},
  setup(props) {
    const store = useStore();
    const formRef = ref<null | HTMLFormElement>(null);
    const editProductModalRef = ref<null | HTMLElement>(null);
    const loading = ref<boolean>(false);
    const formData = ref({
      skuID: props.product && props.product.name,
      title: props.product && props.product.title,
      box: props.product && props.product.box,
      min: props.product && props.product.min.toString(),
      max: props.product && props.product.max.toString()
    });

    watch(() => props.product, first => {
      formData.value = first
      formData.value.min = first.min.toString()
      formData.value.max = first.max.toString()
    });

    const rules = ref({
      skuID: [
        {
          required: true,
          message: "SKU ID is required",
          trigger: "change",
        },
      ],
      title: [
        {
          required: true,
          message: "Title is required",
          trigger: "change",
        },
      ],
      min: [
        {
          required: true,
          min: 0,
          message: "Min is required",
          trigger: "change",
        },
      ],
      max: [
        {
          required: true,
          min: 0,
          message: "Max required",
          trigger: "change",
        },
      ]
    });

    const submit = () => {
      if (!formRef.value) {
        return;
      }

      formRef.value.validate((valid) => {
        if (valid) {
          loading.value = true;

          setTimeout(() => {
            loading.value = false;

            store
                .dispatch(Actions.UPDATE_PRODUCT, formData.value)
                .then(() => {
                  loading.value = false;
                  props.reloadData()
                  hideModal(editProductModalRef.value);
                })
                .catch(() => {
                  loading.value = false;

                  Swal.fire({
                    text: store.getters.getErrors[0],
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Try again!",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-danger",
                    },
                  });
                });
          }, 2000);
        } else {
          Swal.fire({
            text: "Sorry, looks like there are some errors detected, please try again.",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return false;
        }
      });
    };

    return {
      formData,
      rules,
      submit,
      formRef,
      loading,
      editProductModalRef,
    };
  },
});
